export default "__VITE_ASSET__BYFx$w29__"